class CollectionToolbarMobile {
  constructor() {
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.applyModal = this.applyModal.bind(this);
    this.init();
  }

  init() {
    document.querySelectorAll('.collection-toolbar-mobile__trigger').forEach((trigger) => {
      trigger.removeEventListener('click', this.openModal);
      trigger.addEventListener('click', this.openModal);
    });

    document.querySelectorAll('[data-mobile-modal-close]').forEach((button) => {
      button.removeEventListener('click', this.closeModal);
      button.addEventListener('click', this.closeModal);
    });

    document.querySelectorAll('[data-mobile-modal-apply]').forEach((button) => {
      button.removeEventListener('click', this.applyModal);
      button.addEventListener('click', this.applyModal);
    });

    document.querySelectorAll('.collection-mobile-sort__input:checked + .collection-mobile-sort__label').forEach((label) => {
      label.closest('.collection-mobile-sort__item')?.classList.add('is-selected');
    });

    document.querySelectorAll('.collection-mobile-sort__input').forEach((input) => {
      input.addEventListener('change', (event) => {
        const list = event.target.closest('.collection-mobile-sort__list');
        list?.querySelectorAll('.collection-mobile-sort__item').forEach((item) => item.classList.remove('is-selected'));
        event.target.closest('.collection-mobile-sort__item')?.classList.add('is-selected');
      });
    });
  }

  openModal(event) {
    const modalName = event.currentTarget.dataset.mobileModal;
    if (!modalName) return;

    this.closeAllModals();

    const modal = document.querySelector(`.collection-mobile-modal[data-mobile-modal="${modalName}"]`);
    const trigger = document.querySelector(`.collection-toolbar-mobile__trigger[data-mobile-modal="${modalName}"]`);

    if (!modal) return;

    modal.hidden = false;
    document.body.classList.add('collection-mobile-modal-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  closeModal(event) {
    const modal = event.currentTarget.closest('.collection-mobile-modal');
    if (!modal) return;

    modal.hidden = true;

    const modalName = modal.dataset.mobileModal;
    const trigger = document.querySelector(`.collection-toolbar-mobile__trigger[data-mobile-modal="${modalName}"]`);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (!document.querySelector('.collection-mobile-modal:not([hidden])')) {
      document.body.classList.remove('collection-mobile-modal-open');
    }
  }

  closeAllModals() {
    document.querySelectorAll('.collection-mobile-modal').forEach((modal) => {
      modal.hidden = true;
    });

    document.querySelectorAll('.collection-toolbar-mobile__trigger').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    document.body.classList.remove('collection-mobile-modal-open');
  }

  applyModal(event) {
    const modal = event.currentTarget.closest('.collection-mobile-modal');
    const form = document.getElementById('FacetFiltersFormMobile');

    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (modal) {
      modal.hidden = true;
      const modalName = modal.dataset.mobileModal;
      const trigger = document.querySelector(`.collection-toolbar-mobile__trigger[data-mobile-modal="${modalName}"]`);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    if (!document.querySelector('.collection-mobile-modal:not([hidden])')) {
      document.body.classList.remove('collection-mobile-modal-open');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.collectionToolbarMobile = new CollectionToolbarMobile();
});

document.addEventListener('shopify:section:load', () => {
  window.collectionToolbarMobile?.init();
});

document.addEventListener('facets:rendered', () => {
  window.collectionToolbarMobile?.init();
  window.collectionFilterPrice?.init();
});
